import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class CryptoService {
    constructor(
        private readonly http: HttpClient
    ) {
    }

    encrypt(value: string): Observable<string> {
        return this.http.post<string>(location.origin + "/api/application/encrypt", { json: value });
    }

    encryptObj(value: string): Observable<string> {
        return this.http.post<string>(location.origin + "/api/application/encrypt-object", { json: value });
    }

    decrypt(value: string): Observable<string> {
        return this.http.post<string>(location.origin + "/api/application/decrypt", { json: value });
    }

    decryptObject(value: string): Observable<string> {
        return this.http.post<string>(location.origin + "/api/application/decrypt-object", { json: value });
    }
}